export default "__VITE_ASSET__WWSfJ7uJ__"